module.exports = __webpack_public_path__ + "img/music_025.c542a93f.png";